import React, { useState, useEffect } from "react";
import "./CookieBanner.css";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("cookiesAccepted");
    if (!accepted) setVisible(true);
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookiesAccepted", "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner">
      <p>
        Ce site utilise uniquement des cookies essentiels au bon fonctionnement.
        Consultez notre politique de cookies dans la section{" "}
        <strong>Contact</strong>.
      </p>

      <button onClick={acceptCookies}>OK</button>
    </div>
  );
};

export default CookieBanner;
